import UserStore from "./userStore";
import { createContext } from "react";
import { configure, makeAutoObservable } from "mobx";
import CommonStore from "./commonStore";
import ModalStore from "./modalStore";
import ListOfValoursStore from "./listOfValoursStore";
import CompanyStore from "./companyStore";
import UserAdminStore from "./userAdminStore";
import ButtonLoadingStore from "./buttonLoadingStore";
import ResolutionStore from "./resolutionStore";
import CertificateStore from "./certificateStore";
import TrackDocumentStore from "./trackDocumentStore";
import TrackPayrollStore from "./trackPayrollStore";
import InvoiceStore from "./invoiceStore";
import DashboarStore from "./dashboardStore";

configure({ enforceActions: "always" });

export class RootStore {
  userStore: UserStore;
  commonStore: CommonStore;
  modalStore: ModalStore;
  listOfValours: ListOfValoursStore;
  companyStore: CompanyStore;
  userAdminStore: UserAdminStore;
  buttonLoadingStore: ButtonLoadingStore;
  resolutionStore: ResolutionStore;
  certificateStore: CertificateStore;
  trackDocumentStore: TrackDocumentStore;
  trackPayrollStore: TrackPayrollStore;
  invoiceStore: InvoiceStore;
  dashboardStore: DashboarStore;
  constructor() {
    makeAutoObservable(this);
    this.userStore = new UserStore(this);
    this.commonStore = new CommonStore(this);
    this.modalStore = new ModalStore(this);
    this.listOfValours = new ListOfValoursStore(this);
    this.companyStore = new CompanyStore(this);
    this.userAdminStore = new UserAdminStore(this);
    this.buttonLoadingStore = new ButtonLoadingStore(this);
    this.resolutionStore = new ResolutionStore(this);
    this.certificateStore = new CertificateStore(this);
    this.trackDocumentStore = new TrackDocumentStore(this);
    this.trackPayrollStore = new TrackPayrollStore(this);
    this.invoiceStore = new InvoiceStore(this);
    this.dashboardStore = new DashboarStore(this);
  }
}

export const RootStoreContext = createContext(new RootStore());
